import { render, staticRenderFns } from "./ButtonTemplate.vue?vue&type=template&id=8b1e8c38&min-width=650px&"
import script from "./ButtonTemplate.vue?vue&type=script&lang=js&"
export * from "./ButtonTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports